// used to tell it that on import use exports.default
exports.__esModule = !0;

const theme = {
  colors: {
    primary: '#00AD50',
    accent: '#333333',
    buttonHoverText: 'rgba(255, 255, 255, 0.5)',
    pageBackground: '#e6e6e6',
    error: '#E53935',
    white: '#ffffff',
  },
  fontFamily: '"Montserrat",sans-serif',
};

exports.default = theme;

exports.cssThemeVariables = {
  'preferred-font': '"Montserrat",sans-serif',
  'header-font': '"Montserrat",sans-serif',
  'green': '#00AD50',
  'red': '#E53935',
  'black': '#333333',
  'grey': '#5C5C5C',
  'page-background': '#e6e6e6',
  'white': '#ffffff',
  'border-color': '#C2C2C2',

  'color-primary': 'var(--green)',
  'color-primary-dark': 'color(var(--color-primary) shade(10%))',
  'color-accent': 'var(--black)',
  'color-accent-dark': 'color(var(--color-accent) shade(10%))',
  'color-primary-contrast': 'var(--color-dark-contrast)',
  'color-accent-contrast': 'var(--color-dark-contrast)',
};


// WEBPACK FOOTER //
// ./src/theme.js